module.exports = __webpack_public_path__ + "static/media/gold_bag.44038acb.webp";